/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitTestingEntityRelationResponse
 */
export interface MonitTestingEntityRelationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MonitTestingEntityRelationResponse
     */
    ok?: boolean;
}

/**
 * Check if a given object implements the MonitTestingEntityRelationResponse interface.
 */
export function instanceOfMonitTestingEntityRelationResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitTestingEntityRelationResponseFromJSON(json: any): MonitTestingEntityRelationResponse {
    return MonitTestingEntityRelationResponseFromJSONTyped(json, false);
}

export function MonitTestingEntityRelationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitTestingEntityRelationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ok': !exists(json, 'ok') ? undefined : json['ok'],
    };
}

export function MonitTestingEntityRelationResponseToJSON(value?: MonitTestingEntityRelationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ok': value.ok,
    };
}

